import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Home } from 'lucide-react'
import { AuthLayout } from '@/components/AuthLayout'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

export function NotFoundPage() {
  const { t } = useTranslation(['common'])

  return (
    <AuthLayout>
      <div className="flex justify-center mb-8">
        <img src="/images/logo.png" alt="The Ranch" className="h-20 w-auto" />
      </div>

      <Card>
        <CardContent className="py-10 text-center space-y-4">
          <h1 className="text-6xl font-bold text-primary">404</h1>
          <h2 className="text-xl font-semibold">{t('notFound.title')}</h2>
          <p className="text-muted-foreground">{t('notFound.description')}</p>
          <Button asChild>
            <Link to="/">
              <Home className="h-4 w-4 mr-2" />
              {t('notFound.backHome')}
            </Link>
          </Button>
        </CardContent>
      </Card>
    </AuthLayout>
  )
}
